import React from "react";

const ShopByCat = () => {
  const data = [
    {
      id: 1,
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F6_LivingRoom.WEBP?alt=media&token=7407b23c-0fe8-474e-82a1-b68f5bb56a10",
      title: "Living Room",
    },
    {
      id: 2,
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F7_Lighting.WEBP?alt=media&token=a520727d-1cac-45da-974c-dca0d275ee3c",
      title: "Lighting",
    },
    {
      id: 3,
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F8_Kitchen.WEBP?alt=media&token=2ce8fe2b-19ee-43bf-a4b1-0ae7eba8620b",
      title: "Kitchen",
    },
    {
      id: 4,
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F9_Decoration.WEBP?alt=media&token=d5e45c01-1ffe-4fed-af89-1db6ae09ec2e",
      title: "Decoration",
    },
    {
      id: 5,
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F10_Bathroom.WEBP?alt=media&token=94b22877-daf9-40ea-8f27-218af79f68ed",
      title: "Bathroom",
    },
    {
      id: 6,
      img: "https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F11_Electronics.jpg?alt=media&token=669b6b1f-c76d-48a3-8352-78a251cf74d1",
      title: "Electronics & Gadgets",
    },
  ];
  return (
    <div className="pb-14 lg:px-10 px-2">
      <h1 className="text-center mb-6 text-[22.5px] px-10 titlefont font-medium ">
        Shop By Category
      </h1>
      <div className="grid md:grid-cols-3 grid-cols-2 md:gap-5 gap-3">
        {data?.map((item) => (
          <div className="group">
            <div
              key={item.id}
              className="  flex flex-col-reverse gap-3  items-center cursor-pointer"
            >
              <p className=" group-hover:nav-link text-center titlefont !text-base">
                {item.title}
              </p>
              <div className="border group-hover:-translate-y-4 rounded-lg transition-all ">
                <img
                  src={item.img}
                  className="rounded-lg w-96 md:h-72 h-52  "
                  alt=""
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShopByCat;
